import crudUpdateMd from "@/components/crud-md/actions/Edit";
import permissions from "@/router/userPermissions";

export default [
  {
    path: "portfolios",
    name: "portfolios",
    component: () => import("@/modules/hollymontt-admin/views/PortfoliosCrud.vue"),
    meta: {
      auth: permissions.scopes.admin,
      serviceName: "portfolios",
      title: "Carteras de usuarios",
    },
  },
  {
    path: "portfolios/editor",
    name: "portfolioEditor",
    component: () => import("@/modules/hollymontt-admin/views/PortfolioEditor.vue"),
    meta: {
      auth: permissions.scopes.admin,
      title: "Editar cartera por ID",
    },
  },
  {
    path: "portfolios/regenerate-values",
    name: "portfolioRegenerateValues",
    component: () => import("@/modules/hollymontt-admin/views/PortfolioRegenerateValues.vue"),
    meta: {
      auth: permissions.scopes.admin,
      title: "Regenerar valores de cartera",
    },
  },
  {
    path: "portfolios/regenerate-values-by-assets",
    name: "portfolioRegenerateValuesByAssets",
    component: () =>
      import("@/modules/hollymontt-admin/views/PortfolioRegenerateValuesByAssets.vue"),
    meta: {
      auth: permissions.scopes.admin,
      title: "Regenerar valores por activos",
    },
  },
  {
    path: "portfolios/:id/editions",
    name: "portfolioEditions",
    component: () => import("@/modules/hollymontt-admin/views/PortfolioEditionHistory.vue"),
    meta: {
      auth: permissions.scopes.admin,
      title: "Historial de ediciones de cartera",
    },
  },
  {
    path: "portfolios/:id",
    name: "portfoliosEdit",
    component: crudUpdateMd,
    meta: {
      auth: permissions.scopes.admin,
      parentPathNames: ["portfolios"],
      serviceName: "portfolios",
      title: "Cartera de usuario",
    },
  },
];
